import { Box } from '@chakra-ui/react';
import React, { useState, useMemo } from 'react';

import { useGetLimitedPartnerFacilitiesForLenderQuery } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { AliasMatchingFilters } from './AliasMatchingFilters';
import { AliasMatchingTablesContainer } from './AliasMatchingTable';
import { MatchStatusCardsContainer } from './MatchStatusCards';
import { MatchStatus } from './types';
import { Typography } from 'packages/common-frontend/components/Typography';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';
import { dashboardRoutePadding } from '~/packages/common-frontend/constants';

export const AliasMatching = () => {
  const { user } = useUserAuthOrThrow();

  const {
    data: facilitiesData,
    error: facilitiesError,
    refetch: refetchFacilities,
  } = useGetLimitedPartnerFacilitiesForLenderQuery({
    variables: { lenderOrganizationId: user.organizationId },
    fetchPolicy: 'cache-and-network',
  });

  if (facilitiesError) throw facilitiesError;

  const [matchStatusForTables, setMatchStatusForTables] = useState<MatchStatus>(
    'all',
  );

  const [searchQuery, setSearchQuery] = useState('');

  const facilities = useMemo(() => facilitiesData?.limitedPartnerFacilities, [
    facilitiesData,
  ]);

  return (
    <Box padding={dashboardRoutePadding}>
      <Breadcrumbs
        breadcrumbs={[{ label: 'Limited Partners', path: `/limited-partners` }]}
      />
      <Typography variant="page-title" TextProps={{ mt: '1.5rem' }}>
        Match LP Alias
      </Typography>
      <MatchStatusCardsContainer
        facilities={facilities}
        matchStatusForTables={matchStatusForTables}
        setMatchStatusForTables={setMatchStatusForTables}
      />
      <AliasMatchingFilters setSearchQuery={setSearchQuery} />
      <AliasMatchingTablesContainer
        facilities={facilities}
        lenderOrganizationId={user.organizationId}
        searchQuery={searchQuery}
        matchStatusForTables={matchStatusForTables}
        refetchFacilities={refetchFacilities}
      />
    </Box>
  );
};
